import { PRODUCTS_DATA_API, PRODUCTS_DATA_LOCAL } from '@models/clientProductFirebaseModels';
import { db } from '@config/firebaseConfig';
import { collection, getDocs } from "firebase/firestore";
import {USE_FIREBASE} from "@config/appConfig";

/**
 * It retrieves the product list from an external API or a local file.
 */

const productsCollection = collection(db, "products");

/**
 * Fetches products from Firebase or the Local file depending on the configuration.
 */
export const getProducts = async () => {
    if (!USE_FIREBASE) {
        return PRODUCTS_DATA_LOCAL
            .map(item => new PRODUCTS_DATA_API(item))
            .filter(product => product.is_active === true);
    }

    try {
        const querySnapshot = await getDocs(productsCollection);

        return querySnapshot.docs
            .map((docSnap) => {
                const data = { id: docSnap.id, _id: docSnap.id, ...docSnap.data() };
                return new PRODUCTS_DATA_API(data);
            })
            .filter(product => product.is_active === true);

    } catch (error) {
        console.error("Error retrieving products from Firebase using local resources:", error);

        return PRODUCTS_DATA_LOCAL
            .map(item => new PRODUCTS_DATA_API(item))
            .filter(product => product.is_active === true);
    }
};